import './sidenav-item.scss'
import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

function SideNavItem({
    heading,
    icon,
    children,
    active,
    setActive,
    open,
    navigateTo
} : {
    heading: any,
    icon: any,
    children: any[],
    active: any,
    setActive: Dispatch<SetStateAction<any>>,
    open: boolean,
    navigateTo: string
}) {
    const elRef = useRef<any>(null);
    const navigate = useNavigate();

    const toggle = (e: any) => {
        if (e === active) {
            setActive(null);
        } else {
            setActive(e);
        }
    }

    useEffect(() => {
        if (!open) {
            setActive(null);
        }
    }, [open, setActive])

    return (
        <div className="sidenav-item"  onClick={e => navigate(navigateTo)}>
            {children.length ? 
                <div className="sidenav-item-heading dropdown" onClick={e => toggle(e.currentTarget.nextSibling)}>{icon} {heading} <i className="fal fa-angle-down"></i></div> : 
                <div className="sidenav-item-heading">{icon} {heading}</div>
            } 
            <div 
                className="sidenav-item-content"
                ref={elRef}
                style={
                    active && active === elRef.current
                        ? { height: elRef.current.scrollHeight, opacity: 1, overflow: 'unset' }
                        : { height: 0, opacity: 0, overflow: 'hidden' }
                }
            >
                {children.map((x: any, i: number) => {
                    return (
                        <SideNavItem 
                            heading={x.heading}
                            setActive={x.disabled}
                            active={active && active === elRef.current}
                            key={i} icon={undefined} 
                            children={[]} 
                            open={false} 
                            navigateTo={x.navigateTo}                        
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default SideNavItem;